/* tslint:disable */
/* eslint-disable */
/**
 * LPPSWebApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { formatDateOnly, mapValues } from '../runtime';
import type { ContactIdMapping } from './ContactIdMapping';
import {
    ContactIdMappingFromJSON,
    ContactIdMappingFromJSONTyped,
    ContactIdMappingToJSON,
    ContactIdMappingToJSONTyped,
} from './ContactIdMapping';

/**
 * 
 * @export
 * @interface MigrateContactsRequest
 */
export interface MigrateContactsRequest {
    /**
     * 
     * @type {Array<ContactIdMapping>}
     * @memberof MigrateContactsRequest
     */
    mappings: Array<ContactIdMapping>;
}

/**
 * Check if a given object implements the MigrateContactsRequest interface.
 */
export function instanceOfMigrateContactsRequest(value: object): value is MigrateContactsRequest {
    if (!('mappings' in value) || value['mappings'] === undefined) return false;
    return true;
}

export function MigrateContactsRequestFromJSON(json: any): MigrateContactsRequest {
    return MigrateContactsRequestFromJSONTyped(json, false);
}

export function MigrateContactsRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): MigrateContactsRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'mappings': ((json['mappings'] as Array<any>).map(ContactIdMappingFromJSON)),
    };
}

export function MigrateContactsRequestToJSON(json: any): MigrateContactsRequest {
    return MigrateContactsRequestToJSONTyped(json, false);
}

export function MigrateContactsRequestToJSONTyped(value?: MigrateContactsRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'mappings': ((value['mappings'] as Array<any>).map(ContactIdMappingToJSON)),
    };
}

